module.exports = function anonymous(it
) {
var out='<div class="references-list results-container"> <div class="js-def-search-result-container"></div> <div class="right-aligned"> <a class="js-def-search-link" href="#" target="_blank"> <span>'+(it.defSearchUrlText)+'</span> </a> </div></div>';return out;
}